import type { SVGProps } from 'react';
const SvgPhotoSizeSelectActual = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#photo_size_select_actual_svg__a)">
      <path
        fill="currentColor"
        d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2ZM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5Z"
      />
    </g>
    <defs>
      <clipPath id="photo_size_select_actual_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhotoSizeSelectActual;
